import { Axios } from '@/utils/axios';

export class outboundAPI extends Axios {
  constructor() {
    super();
  }

  public async outboundEms(payload: api.outbound.globalMailPayload) {
    try {
      const { data } = await this.axios.post('/v2/outbound/ems', payload);
      return data;
    } catch (e) {
      throw e;
    }
  }
  public async outboundDhl(payload: api.outbound.globalMailPayload) {
    try {
      const { data } = await this.axios.post('/v2/outbound/dhl', payload);
      return data;
    } catch (e) {
      throw e;
    }
  }
  public async outboundFedex(payload: api.outbound.globalMailPayload) {
    try {
      const { data } = await this.axios.post('/v2/outbound/fedex', payload);
      return data;
    } catch (e) {
      throw e;
    }
  }
  public async outboundUps(payload: api.outbound.globalMailPayload) {
    try {
      const { data } = await this.axios.post('/v2/outbound/ups', payload);
      return data;
    } catch (e) {
      throw e;
    }
  }
}
